import React, { useState } from 'react';

const Ninetenththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Rose Gold */
            --primary: #be185d;       /* Pink 700 */
            --primary-light: #fbcfe8; /* Pink 200 */
            --accent: #d4af37;        /* Gold */
            --bg-body: #fff1f2;       /* Rose 50 */
            --bg-white: #ffffff;
            --text-main: #881337;     /* Rose 900 */
            
            --font-head: 'Playfair Display', serif;
            --font-body: 'Lora', serif;
        }

        body { font-family: var(--font-body); background-color: var(--bg-body); color: var(--text-main); margin: 0; line-height: 1.8; }
        h1, h2, h3, h4 { font-family: var(--font-head); font-weight: 700; color: var(--primary); }
        .container { max-width: 1100px; margin: 0 auto; padding: 0 30px; }
        
        .btn { display: inline-block; padding: 12px 30px; background: var(--primary); color: white; border: 1px solid var(--primary); font-family: var(--font-body); letter-spacing: 1px; cursor: pointer; transition: 0.3s; }
        .btn:hover { background: white; color: var(--primary); }
        
        .top-nav { padding: 30px 0; text-align: center; border-bottom: 1px solid #fed7aa; }
        .logo { font-size: 2.5rem; letter-spacing: 2px; color: var(--text-main); text-transform: uppercase; }
        
        .hero { padding: 100px 0; text-align: center; position: relative; overflow: hidden; }
        .hero::after { content: ''; position: absolute; width: 600px; height: 600px; background: radial-gradient(circle, rgba(251,207,232,0.5) 0%, transparent 70%); top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: -1; }
        .hero h1 { font-size: 4rem; font-style: italic; margin-bottom: 20px; }
        
        .divider { width: 60px; height: 2px; background: var(--accent); margin: 30px auto; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 40px; }
        .card { background: white; padding: 40px; text-align: center; border: 1px solid #fecdd3; transition: 0.4s; }
        .card:hover { border-color: var(--accent); box-shadow: 0 10px 30px rgba(190, 24, 93, 0.05); }
        
        .icon-circle { width: 70px; height: 70px; border: 1px solid var(--accent); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 1.5rem; color: var(--primary); }
        
        .product-img { height: 250px; overflow: hidden; margin-bottom: 20px; position: relative; }
        .product-img img { width: 100%; height: 100%; object-fit: cover; }
        
        .footer { background: white; border-top: 1px solid #fecdd3; padding: 60px 0; text-align: center; margin-top: 80px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,600;1,400&family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" />

            <div className="top-nav">
                <div className="container">
                    <div className="logo">{get_data.service_name}</div>
                    <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '30px', fontFamily: 'var(--font-head)', fontStyle: 'italic'}}>
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Collection</a>
                        <a href="#contact">Contact</a>
                    </div>
                </div>
            </div>

            <div className="hero">
                <div className="container">
                    <h1>Elegance & Beauty</h1>
                    <div className="divider"></div>
                    <p style={{fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto 40px'}}>Discover a world where quality meets sophistication. We curate experiences that linger in memory.</p>
                    <a href="#products" className="btn">View Collection</a>
                </div>
            </div>

            <div className="section" id="services" style={{padding: '80px 0'}}>
                <div className="container">
                    <h2 style={{textAlign: 'center', fontSize: '3rem', marginBottom: '60px'}}>Our Craft</h2>
                    <div className="grid">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="card" key={index}>
                                <div className="icon-circle">
                                     {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover'}} alt=""/> : <span>✾</span>}
                                </div>
                                <h3>{item.name}</h3>
                                <p style={{color: '#9f1239', fontSize: '0.95rem'}}>{item.description}</p>
                                <a href="#contact" style={{display: 'inline-block', marginTop: '20px', borderBottom: '1px solid var(--primary)', paddingBottom: '2px'}}>Enquire</a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="section" id="products" style={{background: 'white', padding: '80px 0'}}>
                <div className="container">
                     <h2 style={{textAlign: 'center', fontSize: '3rem', marginBottom: '60px'}}>The Collection</h2>
                     <div className="grid">
                         {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="card" key={index} style={{padding: '20px'}}>
                                <div className="product-img">
                                    <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} alt={item.service_name}/>
                                </div>
                                <h3 style={{fontSize: '1.5rem'}}>{item.service_name}</h3>
                                {item.price && <div style={{color: 'var(--accent)', fontSize: '1.2rem', margin: '10px 0', fontFamily: 'var(--font-head)'}}>₹{item.price}</div>}
                                <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', marginTop: '15px'}}>Add to Bag</button>
                            </div>
                         ))}
                     </div>
                </div>
            </div>

            <div className="footer" id="contact">
                <div className="container">
                    <h2 style={{fontSize: '2rem', marginBottom: '20px'}}>{get_data.service_name}</h2>
                    <p>{get_data.business_location_name}</p>
                    <p style={{fontStyle: 'italic', marginTop: '10px'}}>{get_data.email} — {get_data.mobile}</p>
                    <div style={{marginTop: '40px', borderTop: '1px solid #eee', paddingTop: '20px', fontSize: '0.8rem'}}>
                        &copy; {new Date().getFullYear()} All rights reserved.
                    </div>
                </div>
            </div>
        </>
    );
};

export default Ninetenththeme;
